// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0

import { marked } from "marked";

const escapeHtml = (html) =>
	html.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

// HTML deaktivieren
marked.use({
	renderer: {
		html(html) {
			return escapeHtml(html);
		},
	},
	gfm: true,
	pedantic: false,
});

marked.setOptions({
	breaks: true, // Wichtig für Zeilenumbrüche
	gfm: true,
});

export function renderMarkdown(markdown) {
	const fixedMarkdown = markdown.replace(/<br\s*\/?>/gi, "  \n");
	return marked(fixedMarkdown);
}
